import type { PaginationType as ApiPaginationType } from '@arhs-fleetback/types/entities/common';

export const APP_TITLE = 'Fleetback App';
export const LOCAL_STORAGE_KEY = 'http://fleetback.com:state';
export const LOCAL_STORAGE_FILTERS_KEY = 'http://fleetback.com:filters';
const LOCAL_STORAGE_PERMISSION_DENIED = 'notification_permission_denied';
export const getPermissionDeniedKey = (userId: string) => `${LOCAL_STORAGE_PERMISSION_DENIED}-${userId}`;

export const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'acceptance';
export const IS_CYPRESS = typeof window !== 'undefined' && 'Cypress' in window;

export const API_TIME_FORMAT = 'HH:mm:ss';
export const API_DATE_FORMAT = 'yyyy-MM-dd';

export const DEFAULT_UX_DATE_FORMAT = 'MM/dd/yyyy';
export const DEFAULT_SHORT_UX_DATE_FORMAT = 'MM/dd/yy';

export const MS = 'MS';
export const MR = 'MR';
export const NONE = 'NONE';
export const COMPANY = 'COMPANY';
export const CIVILITIES = [MS, MR, NONE, COMPANY];

export const BOOL = ['True', 'False'];

export const MAX_RECORD = 99999;
export const MAX_PRICE = 999999999;

export const DEFAULT_CURRENCY_ISO_CODE = 'XXX';

export const WTD = 'WTD';
export const WEEK = 'WEEK';
export const TWO_WEEKS = 'TWO_WEEKS';
export const MTD = 'MTD';
export const MONTH = 'MONTH';
export const QUARTER = 'QUARTER';
export const YTD = 'YTD';
export const HALF_YEAR = 'HALF_YEAR';
export const YEAR = 'YEAR';
export const PERIOD_DEFAULT_ITEMS = [WTD, WEEK, MTD, MONTH, QUARTER, YTD, YEAR];

export const SILVER = 'SILVER';
export const GOLD = 'GOLD';
export const PLATINUM = 'PLATINUM';
export const PACKS = {
  SILVER,
  GOLD,
  PLATINUM
};

export const RETRY_NUMBER_TIMES = 8;
export const INTERMEDIATE_SCREEN_WIDTH = 1440;
export const MEDIUM_SCREEN_WIDTH = 1200;
export const PAGE_WIDTH = () => window.innerWidth || document.body.clientWidth;

export const DEBOUNCE_TIME = 500;
export const CODE_ERRORS = {
  BAD_REQUEST: 400,
  CONFLICT_ERROR: 409
};

export const DMS_TYPE = {
  CARYA: 'Carya',
  MILES: 'Miles',
  DYNAMO: 'Dynamo',
  VEACT: 'Veact',
  XPOWER: 'XPower'
};

/**
 * TODO: drop this mirror once @arhs-fleetback/types exposes PaginationType as a plain object, the
 * way it does MediaSubTypeEnum — it ships only the zod `PaginationTypeEnum` today, and reading its
 * members at runtime would pull zod into the bundle. `satisfies` keeps the two in step until then.
 */
export const PaginationType = {
  SLICE: 'SLICE',
  PAGE: 'PAGE'
} as const satisfies Record<string, ApiPaginationType>;

/** @typedef {'SIGNED' | 'UNSIGNED'} SignatureStatus */
/** @type {Record<SignatureStatus, string>} */
export const SIGNATURE_STATUS = {
  SIGNED: 'SIGNED',
  UNSIGNED: 'UNSIGNED'
};
export type SIGNATURE_STATUS = (typeof SIGNATURE_STATUS)[keyof typeof SIGNATURE_STATUS];

export const SOCIAL_NETWORKS = ['FACEBOOK', 'INSTAGRAM', 'YOUTUBE', 'LINKEDIN', 'X'];

export const LIMITED_PAGER_SIZES = [10, 20, 50];

/** @typedef {'DEGRADED' | 'HEALTHY' | 'RELEASING' | 'UNHEALTHY' | 'PLANNED_MAINTENANCE'} HealthStatus */
export const HEALTH_STATUS = {
  DEGRADED: 'DEGRADED',
  HEALTHY: 'HEALTHY',
  RELEASING: 'RELEASING',
  UNHEALTHY: 'UNHEALTHY',
  PLANNED_MAINTENANCE: 'PLANNED_MAINTENANCE'
};
